import React, { Suspense } from 'react';
import { LoadingPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { string } from 'prop-types';

const RoomVo = React.lazy(() => import(/* webpackChunkName: "augmented-reality" */'@thd-olt-component-react/augmented-reality')
  .then((module) => ({ default: module.RoomVo })));

const RoomVoFallback = () => {
  return (
    <LoadingPlaceholder
      type="textRow"
      showLoadingAnimation
      style={{ height: '37px' }}
    />
  );
};

export const MediaGalleryARRoomVoLazy = ({ itemId }) => {
  return (
    <Suspense fallback={<RoomVoFallback />}>
      <RoomVo itemId={itemId} />
    </Suspense>
  );
};

MediaGalleryARRoomVoLazy.displayName = 'MediaGalleryARLazy';

MediaGalleryARRoomVoLazy.propTypes = {
  itemId: string.isRequired
};
